import React from "react";
import PropTypes from "prop-types";
import styles from "./FormError.module.scss";

const FormError = ({
  errorMessage
}) => {
  if (!errorMessage) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.text
  }, errorMessage));
};

FormError.propTypes = {
  errorMessage: PropTypes.string
};
export default FormError;